import React, { useEffect, useState } from 'react';
import { RiAddCircleFill } from 'react-icons/ri';
import { usePatient } from '../contexts/patient';
import { FaClinicMedical, FaFlask, FaUserNurse, FaUserMd, FaMoneyBill, FaShieldAlt, FaPills, FaTrain, FaChalkboardTeacher, FaHeartBroken, FaBed, FaBuilding, FaStore, FaBuyNLarge, FaFile, FaExclamationCircle } from 'react-icons/fa';
import finance from '../assets/images/finance.svg';
import insurance from '../assets/images/Insurance.svg';
import referral from '../assets/images/referral.svg';
import dashboard from '../assets/images/dshb.svg';
import facility from '../assets/images/faclty.svg';
import patient from '../assets/images/pats.svg';
import { get } from '../utility/fetch';

const useNavigationItems = () => {
    const userInfo = JSON.parse(localStorage.getItem('USER_INFO'));
    const Role = userInfo?.role || []; // Ensure Role is always an array
    const employeeId = userInfo?.employeeId;

    const moduleList = JSON.parse(sessionStorage.getItem('moduleList') || '[]');

    

    console.log(Role);

    const iconMap = {
        ClinicAdministration: <FaClinicMedical style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Laboratory: <FaFlask style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Nurse: <FaUserNurse style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Doctor: <FaUserMd style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Finance: <FaMoneyBill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Pharmacy: <FaPills style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        // 'Human Resources': <FaChalkboardTeacher style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Grievance: <FaHeartBroken style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        // 'Asset Management': <FaBuilding style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        // "Admin & Store": <FaStore style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Expense: <FaBuyNLarge style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        // 'Memo Manager': <FaFile style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Payroll: <FaUserMd style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
    };

    // Map roles to categories
    const roleToCategoryMap = {
        HealthFinanceAdmin: 'Finance', // Ensure this role maps to the Finance category
        Nurse: 'Nurse',
        Doctor: 'Doctor',
        LabTechnician: 'Laboratory',
        MedicalLaboratoryTechnician: 'Laboratory',
        checkin: 'ClinicAdministration',
        LocalAdmin: 'ClinicAdministration',
        Pharmacist: 'Pharmacy',
        VitalNurse: 'Nurse',
        AdminStaff: ['Asset Management', 'Inventory Warehouse'],
        Finance: ['Expense', 'Payroll'],
    };

    // Convert the roles to their respective categories
    const allowedCategories = Role?.flatMap((role) => {
        const cleanedRole = role?.replace(/\s+/g, '');
        console.log('cleanedRole', cleanedRole);
        return roleToCategoryMap[cleanedRole] || roleToCategoryMap[cleanedRole]?.map((cat) => cat);
    }).filter(Boolean);

    console.log('allowedCategories', allowedCategories);
    console.log('Role', Role);

    // Ensure "Health Finance Admin" sees Finance modules
    if (Role.includes('Health Finance Admin') && !allowedCategories.includes('Finance')) {
        allowedCategories.push('Finance');
    }

    if (employeeId === 153 && !allowedCategories.includes('Finance')) {
        allowedCategories.push('Finance');
    }

    const isTestBuild = process.env.NODE_ENV !== 'production'; // Determine if it's a test build

    console.log('isTestBuild', isTestBuild);
    // Define the categories to be shown
    const visibleCategories = ['Doctor', 'ClinicAdministration', 'Nurse', 'Pharmacy', 'Laboratory', 'Finance', 'Admin & Store'];

    const allStaffCategories = [
        'Asset Management',
        'Memo Manager',
        'Accounts & Budget',
        "Human Resources",
        "Admin & Store", // Add Admin & Store to allStaffCategories
    ];

    // Ensure all variables are declared before use
    const filteredModuleList = moduleList.filter(category => {
        const categoryKey = category.category.replace(/\s+/g, ''); // Declare categoryKey before use

        if (isTestBuild) {
            // Test build logic: Use employeeId
            if (![148, 153].includes(employeeId) && !visibleCategories.includes(categoryKey)) {
                return false;
            }

            if (categoryKey === 'ClinicAdministration' && [148, 153].includes(employeeId)) {
                // Display all submodules for Clinic Administration if employeeId is 148 or 153
                return true;
            }

            if (
                categoryKey === 'Finance' &&
                ![148, 153].includes(employeeId) &&
                (Role.includes('Doctor') || Role.includes('Finance'))
            ) {
                category.module = category.module.filter(subItem => subItem.name === 'Finance');
            }
        } else {
            // Production build logic: Filter by roles and categories
            if (!visibleCategories.includes(categoryKey) && !allStaffCategories.includes(category.category)) {
                return false;
            }

            if (categoryKey === 'ClinicAdministration' && Role.some(r => r.toLowerCase().includes('admin'))) {
                // Allow all submodules for Clinic Administration if the role includes 'admin'
                return true;
            }

            if (categoryKey === 'Finance' && !allowedCategories.includes('Finance')) {
                return false;
            }
        }

        return true;
    });

    const allStaffModules = moduleList.filter(category => allStaffCategories.includes(category.category));

    useEffect(() => {
        // Store allStaffModules in sessionStorage
        sessionStorage.setItem('allStaffModules', JSON.stringify(allStaffModules));
    }, [allStaffModules]);

    // Retrieve allStaffModules from sessionStorage
    const storedAllStaffModules = JSON.parse(sessionStorage.getItem('allStaffModules') || '[]');

    console.log('filteredModuleList', filteredModuleList);

    const menuItems = filteredModuleList
        ?.filter((category) => allowedCategories?.includes(category?.category?.replace(/\s+/g, '')))
        ?.map((category) => {
            const categoryKey = category?.category?.replace(/\s+/g, '');
            const filteredModules = category?.module?.filter((subItem) => {
                if (categoryKey === 'ClinicAdministration') {
                    const allowedSubmodules = [];
                    if (Role.includes('checkin')) allowedSubmodules.push('Patient Admin');
                    if (Role.includes('Local Admin')) allowedSubmodules.push('Clinic Admin');
                    return allowedSubmodules.includes(subItem?.name);
                }
                return true;
            });
            

            return {
                key: category?.category,
                title: categoryKey === 'ClinicAdministration' ? 'Clinic Admin' : category?.category,
                icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                children: isTestBuild && [148, 153].includes(employeeId) && categoryKey === 'ClinicAdministration'
                    ? category.module.map((subItem) => ({
                        title: subItem?.name,
                        href: subItem?.address,
                        icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                    }))
                    : filteredModules?.map((subItem) => ({
                        title: subItem?.name,
                        href: subItem?.address,
                        icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                    })),
            };
        });


        console.log('menuItems', menuItems);
    // Add "All Staff" modules to the menu items
    // if (isTestBuild) {
    if (isTestBuild && [148, 153].includes(employeeId)) {
        storedAllStaffModules.forEach((module) => {
            const categoryKey = module.category;
            menuItems.push({
                key: categoryKey,
                title: categoryKey,
                icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                children: module.module.map((subItem) => ({
                    title: subItem.name,
                    href: subItem.address,
                    icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                })),
            });
        });
    } else if (!isTestBuild) {
        // For production, make allStaffCategories visible for all roles
        allStaffModules.forEach((module) => {
            const categoryKey = module.category;
            menuItems.push({
                key: categoryKey,
                title: categoryKey,
                icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                children: module.module.map((subItem) => ({
                    title: subItem.name,
                    href: subItem.address,
                    icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                })),
            });
        });
    }

    return [...menuItems];
};

export default useNavigationItems;
